// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── AI Chat Panel ── */
.ai-chat-panel {
  display: flex;
  flex-direction: column;
  border-left: 1px solid #e2e8f0;
  background: #fafbfc;
  animation: aiChatSlideIn 0.2s ease;
}

@keyframes aiChatSlideIn {
  from { transform: translateX(20px); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
}

/* ── Resize handle ── */
.ai-chat-resize-handle {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  cursor: col-resize;
  background: transparent;
  transition: background 0.15s;
  z-index: 10;
}

.ai-chat-resize-handle:hover {
  background: #6366f1;
}

/* ── Header ── */
.ai-chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.85rem;
  font-weight: 600;
  color: #1e293b;
  flex-shrink: 0;
}

.ai-chat-header-actions {
  display: flex;
  gap: 4px;
}

.ai-chat-btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  color: #94a3b8;
  font-size: 0.8rem;
  padding: 4px 6px;
  border-radius: 4px;
  transition: all 0.15s;
}

.ai-chat-btn-icon:hover {
  background: #f1f5f9;
  color: #475569;
}

/* ── Messages area ── */
.ai-chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 12px;
}

.ai-chat-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 16px;
}

/* ── Input area ── */
.ai-chat-input-area {
  display: flex;
  gap: 8px;
  padding: 8px 12px;
  border-top: 1px solid #e2e8f0;
  background: #fff;
  flex-shrink: 0;
}

.ai-chat-input {
  flex: 1 1;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 0.82rem;
  resize: none;
  font-family: inherit;
  outline: none;
  transition: border-color 0.15s;
}

.ai-chat-input:focus {
  border-color: #6366f1;
}

.ai-chat-input:disabled {
  background: #f8fafc;
  color: #94a3b8;
}

.ai-chat-send-btn {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  border: none;
  background: linear-gradient(135deg, #6366f1, #4f46e5);
  color: #fff;
  font-size: 1rem;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.15s;
}

.ai-chat-send-btn:hover:not(:disabled) {
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.3);
}

.ai-chat-send-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ── Thinking dots animation ── */
.ai-chat-dots::after {
  content: "";
  animation: aiChatDots 1.5s infinite;
}

@keyframes aiChatDots {
  0% { content: ""; }
  33% { content: "."; }
  66% { content: ".."; }
  100% { content: "..."; }
}
`, "",{"version":3,"sources":["webpack://./src/app/common/AIChat/AIChatPanel.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,KAAK,WAAW,EAAE;EAClB,MAAM,YAAY,EAAE;EACpB,MAAM,aAAa,EAAE;EACrB,OAAO,cAAc,EAAE;AACzB","sourcesContent":["/* ── AI Chat Panel ── */\n.ai-chat-panel {\n  display: flex;\n  flex-direction: column;\n  border-left: 1px solid #e2e8f0;\n  background: #fafbfc;\n  animation: aiChatSlideIn 0.2s ease;\n}\n\n@keyframes aiChatSlideIn {\n  from { transform: translateX(20px); opacity: 0; }\n  to { transform: translateX(0); opacity: 1; }\n}\n\n/* ── Resize handle ── */\n.ai-chat-resize-handle {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 4px;\n  cursor: col-resize;\n  background: transparent;\n  transition: background 0.15s;\n  z-index: 10;\n}\n\n.ai-chat-resize-handle:hover {\n  background: #6366f1;\n}\n\n/* ── Header ── */\n.ai-chat-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #1e293b;\n  flex-shrink: 0;\n}\n\n.ai-chat-header-actions {\n  display: flex;\n  gap: 4px;\n}\n\n.ai-chat-btn-icon {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #94a3b8;\n  font-size: 0.8rem;\n  padding: 4px 6px;\n  border-radius: 4px;\n  transition: all 0.15s;\n}\n\n.ai-chat-btn-icon:hover {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n/* ── Messages area ── */\n.ai-chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 12px;\n}\n\n.ai-chat-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 40px 16px;\n}\n\n/* ── Input area ── */\n.ai-chat-input-area {\n  display: flex;\n  gap: 8px;\n  padding: 8px 12px;\n  border-top: 1px solid #e2e8f0;\n  background: #fff;\n  flex-shrink: 0;\n}\n\n.ai-chat-input {\n  flex: 1;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  padding: 8px 10px;\n  font-size: 0.82rem;\n  resize: none;\n  font-family: inherit;\n  outline: none;\n  transition: border-color 0.15s;\n}\n\n.ai-chat-input:focus {\n  border-color: #6366f1;\n}\n\n.ai-chat-input:disabled {\n  background: #f8fafc;\n  color: #94a3b8;\n}\n\n.ai-chat-send-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 6px;\n  border: none;\n  background: linear-gradient(135deg, #6366f1, #4f46e5);\n  color: #fff;\n  font-size: 1rem;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: all 0.15s;\n}\n\n.ai-chat-send-btn:hover:not(:disabled) {\n  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.3);\n}\n\n.ai-chat-send-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* ── Thinking dots animation ── */\n.ai-chat-dots::after {\n  content: \"\";\n  animation: aiChatDots 1.5s infinite;\n}\n\n@keyframes aiChatDots {\n  0% { content: \"\"; }\n  33% { content: \".\"; }\n  66% { content: \"..\"; }\n  100% { content: \"...\"; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
